import PageSection from "../Layout/PageSection";
import { useFormik } from "formik";
import Button from "../Input/Button";
import FormField from "../Input/FormField";
import Dropdown from "../Input/Dropdown";
import Checkbox from "../Input/Checkbox";
import { API_URL, STATE_LIST } from "../../data/constants";
import TextArea from "../Input/TextArea";
import SummaryItem from "../Layout/SummaryItem";

import { useContext, useEffect, useState } from "react";
import Context from "../../../context";
import dayjs from "dayjs";
import axios from "axios";

export default function Profile({ setSubPage }) {
  const { contextState, setContextState } = useContext(Context);

  let account = contextState.currentAccount;
  const [stateId, setStateId] = useState(account.billingAddressStateId);

  const [paperless, setPaperless] = useState(account.paperless);
  const [creditCardExpiration, setCreditCardExpiration] = useState(
    account.creditCardExpiration
  );
  const [billComingDue, setBillComingDue] = useState(account.billComingDue);
  const [contractExpiration, setContractExpiration] = useState(
    account.contractExpiration
  );
  const [billPastDue, setBillPastDue] = useState(account.billPastDue);
  const [contractExpired, setContractExpired] = useState(
    account.contractExpired
  );
  const [paymentConfirmation, setPaymentConfirmation] = useState(
    account.paymentConfirmation
  );
  const [sonp, setSonp] = useState(account.sonp);

  const [
    billingAddressMatchesServiceAddress,
    setBillingAddressMatchesServiceAddress,
  ] = useState(account.billingAddressMatchesServiceAddress);

  let userRole = localStorage.getItem("userRole");

  const [message, setMessage] = useState();

  useEffect(() => {}, [contextState.currentAccount]);

  function validate(values) {
    const errors={};

    // if(!values.billingName) errors.billingName = 'Required'
    // if(!values.address1) errors.address1 = 'Required'
    // if(!values.city) errors.city = 'Required'
    // if(!values.zip) errors.zip = 'Required'

    return errors
  }

  const myProfileForm = useFormik({
    initialValues: {
      billingName: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
      contactName: "",
      cellPhoneNumber: "",
      workPhoneNumber: "",
      emailAddresses: "",
    },
    validate,
    onSubmit: (values) => {
      setMessage();
      let emails =
        values.emailAddresses.length > 1
          ? values.emailAddresses.split(";")
          : account.emailAddresses;
      axios
        .post(
          API_URL + "/Accounts",
          {
            customerId: account.contract.customerId,
            customerNumber: account.customerNumber,
            masterCustomerId: null,
            paperless: paperless,
            autoPay: account.autoPay,

            billingName:
              values.billingName !== ""
                ? values.billingName
                : account.billingName,

            billingAddressMatchesServiceAddress:
              billingAddressMatchesServiceAddress,

            billingAddressLine1:
              values.address1 !== ""
                ? values.address1
                : account.billingAddressLine1,
            billingAddressLine2:
              values.address2 !== ""
                ? values.address2
                : account.billingAddressLine2,
            billingAddressCity:
              values.city !== "" ? values.city : account.billingAddressCity,

            billingAddressStateId: stateId,

            billingAddressZipCode:
              values.zip !== "" ? values.zip : account.billingAddressZipCode,
            contactName:
              values.contactName !== ""
                ? values.contactName
                : account.contactName,
            cellPhoneNumber:
              values.cellPhoneNumber !== ""
                ? values.cellPhoneNumber
                : account.cellPhoneNumber,
            workPhoneNumber:
              values.workPhoneNumber !== ""
                ? values.workPhoneNumber
                : account.workPhoneNumber,
            emailAddresses: emails,

            creditCardExpiration: creditCardExpiration,
            contractExpiration: contractExpiration,
            contractExpired: contractExpired,
            sonp: sonp,
            billComingDue: billComingDue,
            billPastDue: billPastDue,
            paymentConfirmation: paymentConfirmation,
          },
          { headers: { Authorization: localStorage.getItem("accessToken") } }
        )
        .then((res) => {
          setMessage("Profile Saved Successfully");
          axios
            .get(API_URL + `/Accounts/${localStorage.getItem("username")}`, {
              headers: {
                Authorization: `${localStorage.getItem("accessToken")}`,
              },
            })
            .then((res) => {
              setContextState({
                ...contextState,
                accounts: res.data,
                currentAccount: res.data.find((obj) => {
                  return obj.customerNumber === account.customerNumber;
                }),
              });
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  });

  return (
    <>
      <PageSection sectionName="Account Information" isForm={true}>
        <div className="profile-account-information-container">
          <div className="profile-account-information">
            { userRole !== "IT-User" && (
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Atlanta Gas Light Account #</p>
              <p>{account.aglcAccountNumber}</p>
            </div>
            )}
            { userRole === "IT-User" && (
                <div className="profile-account-information-item">
                  <p className="font-weight-bold">MAIS #</p>
                  <p>{account.maisNumber}</p>
                </div>
            )}
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Customer #</p>
              <p>{account.customerNumber}</p>
            </div>
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Account Name</p>
              <p>{account.customerName}</p>
            </div>
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Start Date</p>
              <p>{dayjs(account.contractStartDate).format("MM/DD/YYYY")}</p>
            </div>
          </div>
          <div className="profile-account-information">
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Service Address</p>
              <p>
                {account.serviceAddressLine1}
                {account.serviceAddressLine2 && (
                  <>
                    <br />
                    {account.serviceAddressLine2}
                  </>
                )}
                <br />
                {account.serviceAddressCity},{" "}
                {
                  STATE_LIST.find(
                    (state) =>
                      Number(state.id) === Number(account.serviceAddressStateId)
                  ).shortName
                }{" "}
                {account.serviceAddressZipCode}
              </p>
            </div>
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Mailing Address</p>
              <p>
                {account.billingAddressLine1}
                {account.billingAddressLine2 && (
                  <>
                    <br />
                    {account.billingAddressLine2}
                  </>
                )}
                <br />
                {account.billingAddressCity},{" "}
                {
                  STATE_LIST.find(
                    (state) =>
                      Number(state.id) === Number(account.billingAddressStateId)
                  ).shortName
                }{" "}
                {account.billingAddressZipCode}
              </p>
            </div>
            <div className="profile-account-information-item">
              <p className="font-weight-bold">Phone Numbers</p>
              <p>
                {account.homePhoneNumber}
                <br />
                {account.cellPhoneNumber}
                <br />
                {account.workPhoneNumber}
              </p>
            </div>
          </div>
        </div>

        <Button
          className="btn btn--green btn--bordered"
          text="Change Password"
          onClick={() => {
            setSubPage("password");
          }}
        />
      </PageSection>
      <form onSubmit={myProfileForm.handleSubmit}>
        <PageSection sectionName="Billing Address" isForm={true}>
          <div className="summary-item-container mb-4">
            <Checkbox
              isSmall
              isChecked={billingAddressMatchesServiceAddress}
              setIsChecked={setBillingAddressMatchesServiceAddress}
            />
            <label className="summary-item-label-header">
              Billing Address is Same as Service Address{" "}
            </label>
          </div>
          <FormField
            name="Send Bill To"
            type="text"
            field="billingName"
            form={myProfileForm}
            placeholder={account.billingName}
          />
          <FormField
            name="Address"
            type="text"
            field="address1"
            form={myProfileForm}
            placeholder={account.billingAddressLine1}
          />
          <FormField
            name="Address Line 2"
            type="text"
            field="address2"
            form={myProfileForm}
            helpText="Company, C/O, Apt., Suite, Unit, Building, Floor, etc..."
            noLabel
            optional
            placeholder={account.billingAddressLine2}
          />
          <div className="form-row">
            <div className="col-12 col-sm-5">
              <FormField
                name="City"
                type="text"
                field="city"
                form={myProfileForm}
                placeholder={account.billingAddressCity}
              />
            </div>
            <div className="col-12 col-sm-3">
              <Dropdown
                text="State"
                data={STATE_LIST}
                setValue={setStateId}
                defaultSelectedValue={account.billingAddressStateId}
              />
            </div>
            <div className="col-12 col-sm-4">
              <FormField
                name="Zip Code"
                type="text"
                field="zip"
                form={myProfileForm}
                placeholder={account.billingAddressZipCode}
              />
            </div>
          </div>
        </PageSection>

        <PageSection sectionName="Contact Information" isForm={true}>
          <FormField
            name="Contact Name"
            type="text"
            field="contactName"
            form={myProfileForm}
            placeholder={account.contactName}
          />
          <div className="form-row">
            <div className="col-12 col-sm-6">
              <FormField
                name="Phone Number"
                type="text"
                field="phoneNumber"
                form={myProfileForm}
                placeholder={account.homePhoneNumber}
              />
            </div>
            <div className="col-12 col-sm-6">
              <FormField
                name="Cell Number"
                type="text"
                field="cellPhoneNumber"
                form={myProfileForm}
                placeholder={account.cellPhoneNumber}
              />
            </div>
          </div>
          <TextArea
            name="Email Address(es)"
            field="emailAddresses"
            helpText="Separate multiple email addresses with a semicolon ( ; )"
            form={myProfileForm}
            placeholder={account.emailAddresses}
          />
          { userRole !== "IT-User" && (
          <SummaryItem
            headerText="Paperless Billing"
            subText="Enabling paperless billing will direct all statements to be sent to you via email."
            isChecked={paperless}
            setIsChecked={setPaperless}
          />
          )}
        </PageSection>
        <PageSection sectionName="Email Alerts" isForm={true}>
          <div className="form-row jutify-content-between">
            { userRole !== "IT-User" && (
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Credit Card Expiration"
                subText="If your credit card used for automatic payments is expiring within 30 days."
                isChecked={creditCardExpiration}
                setIsChecked={setCreditCardExpiration}
              />
            </div>
            )}
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Bill Coming Due"
                subText="Two days before your bill is due."
                isChecked={billComingDue}
                setIsChecked={setBillComingDue}
              />
            </div>
            { userRole !== "IT-User" && (
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Contract Expiration"
                subText="When your fixed-rate contract is expiring within 30 days."
                isChecked={contractExpiration}
                setIsChecked={setContractExpiration}
              />
            </div>
            )}
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Bill Past Due"
                subText="When your bill becomes past due."
                isChecked={billPastDue}
                setIsChecked={setBillPastDue}
              />
            </div>
            { userRole !== "IT-User" && (
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Contract Expired"
                subText="When your fixed-rate contract has expired."
                isChecked={contractExpired}
                setIsChecked={setContractExpired}
              />
            </div>
            )}
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="Payment Confirmation"
                subText="Confirmation when payments are posted to your account."
                isChecked={paymentConfirmation}
                setIsChecked={setPaymentConfirmation}
              />
            </div>
            { userRole !== "IT-User" && (
            <div className="col-12 col-sm-6">
              <SummaryItem
                headerText="SONP"
                subText="If your service is scheduled for disconnection due to non-payment."
                isChecked={sonp}
                setIsChecked={setSonp}
              />
            </div>
            )}
          </div>
        </PageSection>
        {message && <p>{message}</p>}
        <Button
          className="btn btn--green btn--bordered"
          text="Save Changes"
          type="submit"
        />
      </form>
    </>
  );
}
